<div class="db-hosting-domains-manage-all" *ngIf="user?.hosting_services">
  <div class="ds-notification-error" *ngIf="hostingZonesData && hostingZonesData.length >= zoneLimit">
    <div>
      <i class="db-icon db-icon-ds-info-bg"></i>
      <p>
        <b>{{ 'text_zoneLimitExceededTitle' | dbText }} </b>
        <span [innerHTML]="'text_addZoneDnsExceededDesc' | dbText"></span>
      </p>
    </div>
  </div>
  <div class="db-hosting-body-wrap" dbCustomScrollbar>
    <div class="db-hosting-body-content">
      <div class="db-add-zone-wrap">
        <div class="db-add-zone-info">
          <div class="db-add-zone-info-title">{{'text_addDomainDnsTitle' | dbText}}</div>
          <div class="db-add-zone-info-desc" [innerHTML]="'text_addZoneDnsDesc' | dbText"></div>
        </div>
        <div class="db-add-zone-action">
          <a (click)="addZone()" class="ds-btn-black ds-btn" [ngClass]="{'ds-btn-disabled': hostingZonesData && hostingZonesData.length >= zoneLimit}">
            <span>{{'text_addZoneShort' | dbText}}</span>
          </a>
        </div>
      </div>
      <div class="zones-block-wrap">
      <div *ngFor="let zone of hostingZonesData" class="db-dns-block">
        <div class="db-dns-block-wrap">
          <div class="db-panel db-panel_flex">
            <div class="db-panel__header">
              <div class="db-header-wrap">
                <div>
                  <i class="db-icon db-icon-ds-globus"></i>
                  <span>{{zone.name | middleEllipsis: 25}}</span>
                </div>
                <a class="db-link" [routerLink]="['../domains-manage-dns/' + zone.id]">
                  <span>{{'text_manage' | dbText}}</span>
                </a>
              </div>
            </div>
            <div class="db-panel__body db-dns-block-body">
              <div class="body-header">{{'text_nameServers' | dbText}}</div>
              <div class="body-wrap">
                <div class="item-wrap" *ngFor="let nameserver of zone.nameservers">
                  <span class="dot"></span>
                  <span class="nameserver-title">{{nameserver}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</div>
<db-page-not-found *ngIf="!user.hosting_services"></db-page-not-found>
